export default __webpack_public_path__ + "static/media/the-magic-closet.2f8c889c.png";